import { isPlatform } from '@ionic/core';
import classNames from 'classnames';
import React from 'react';

import { CompanyDetailsFooter } from '@/components/CompanyDetailsFooter';
import type {
  UiButtonColorType,
  UiButtonRoundType,
  UiButtonSizeType,
} from '@/components/ui/Button';
import { UiButton } from '@/components/ui/Button';
import '@/pages/Onboarding/components/Footer/Footer.scss';

import { LureScreenFooterStyles } from './LureScreenFooter.styles';

export const LureScreenFooter: React.FC<{
  onContinue: () => void;
  disabled?: boolean;
  hidden?: boolean;
  buttonColor?: UiButtonColorType;
  buttonRadius?: UiButtonRoundType;
  buttonSize?: UiButtonSizeType;
  buttonClassName?: string;
  buttonText?: string;
}> = ({
  onContinue,
  disabled,
  hidden,
  buttonColor = 'primary',
  buttonRadius = 'md',
  buttonSize = 'large',
  buttonClassName,
  buttonText = 'Continue',
}) => {
  React.useEffect(() => {
    const handleNextStep = (event: KeyboardEvent) => {
      if (event.code === 'Space' && !disabled && !hidden) {
        onContinue();
      }
    };

    if (isPlatform('desktop')) {
      document.addEventListener('keypress', handleNextStep);
    }

    return () => {
      if (isPlatform('desktop')) {
        document.removeEventListener('keypress', handleNextStep);
      }
    };
  }, [hidden, disabled, onContinue]);

  return (
    <LureScreenFooterStyles
      className={classNames('onboarding-footer', {
        hidden,
      })}
    >
      <UiButton
        disabled={disabled}
        expand="full"
        round={buttonRadius}
        size={buttonSize}
        color={buttonColor}
        className={classNames('onboarding-footer__button', buttonClassName)}
        onClick={onContinue}
        TEST_ID="onboarding-next"
      >
        {buttonText}
      </UiButton>
      <CompanyDetailsFooter noHorizontalPadding />
    </LureScreenFooterStyles>
  );
};
